(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sln-outfit-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.slnInit) return;
      root.dataset.slnInit = '1';
      var D = root.dataset;
      var data;
      try { data = JSON.parse(root.querySelector('[data-sln-ob-data]').textContent); } catch (e) { return; }
      var fmt;
      try { fmt = new Intl.NumberFormat(D.locale || undefined, { style: 'currency', currency: D.currency || 'USD' }); }
      catch (e) { fmt = { format: function (n) { return n.toFixed(2); } }; }

      var slotsEl = root.querySelector('[data-sln-ob-slots]');
      var listEl = root.querySelector('[data-sln-ob-list]');
      var previewEl = root.querySelector('[data-sln-ob-preview]');
      var totalEl = root.querySelector('[data-sln-ob-total]');
      var bundleEl = root.querySelector('[data-sln-ob-bundle]');
      var addBtn = root.querySelector('[data-sln-ob-add]');
      var contBtn = root.querySelector('[data-sln-ob-continue]');
      var statusEl = root.querySelector('[data-sln-ob-status]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sel = data.slots.map(function () { return null; });
      var cards = data.slots.map(function () { return []; });

      function variantOf(s) {
        for (var i = 0; i < s.p.variants.length; i++) if (s.p.variants[i].id === s.vid) return s.p.variants[i];
        return s.p.variants[0];
      }
      function firstAvail(p) {
        for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
        return null;
      }

      function buildCard(si, p) {
        var li = document.createElement('li');
        li.className = 'sln-ob__card';
        var fa = firstAvail(p);
        var state = { vid: (fa || p.variants[0]).id };
        if (p.image) {
          var im = document.createElement('img');
          im.src = p.image; im.alt = ''; im.loading = 'lazy';
          li.appendChild(im);
        }
        var a = document.createElement('a');
        a.className = 'sln-ob__name'; a.href = p.url; a.textContent = p.title;
        li.appendChild(a);
        var price = document.createElement('p');
        price.className = 'sln-ob__price';
        li.appendChild(price);
        function curV() {
          for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === state.vid) return p.variants[i];
          return p.variants[0];
        }
        function paintPrice() { price.textContent = fmt.format(curV().price / 100); }

        if (p.variants.length > 1) {
          var select = document.createElement('select');
          select.setAttribute('aria-label', p.title);
          p.variants.forEach(function (v) {
            var o = document.createElement('option');
            o.value = String(v.id);
            o.textContent = v.title + (v.available ? '' : ' - ' + D.lblSoldout);
            o.disabled = !v.available;
            select.appendChild(o);
          });
          select.value = String(state.vid);
          select.addEventListener('change', function () {
            state.vid = parseInt(select.value, 10);
            paintPrice();
            if (sel[si] && sel[si].p.id === p.id) sel[si].vid = state.vid;
            render();
          });
          li.appendChild(select);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button--secondary';
        btn.setAttribute('aria-pressed', 'false');
        btn.textContent = D.lblSelect;
        if (!fa) { btn.disabled = true; btn.textContent = D.lblSoldout; }
        btn.addEventListener('click', function () {
          if (sel[si] && sel[si].p.id === p.id) sel[si] = null;
          else sel[si] = { p: p, vid: state.vid };
          render();
        });
        li.appendChild(btn);
        paintPrice();
        cards[si].push({ p: p, li: li, btn: btn });
        return li;
      }

      data.slots.forEach(function (slot, si) {
        var sec = document.createElement('section');
        sec.className = 'sln-ob__slot';
        var head = document.createElement('div');
        head.className = 'sln-ob__slothead';
        var h = document.createElement('h3');
        h.textContent = slot.name;
        head.appendChild(h);
        var track = document.createElement('ul');
        track.className = 'sln-ob__track';
        track.setAttribute('aria-label', slot.name);
        if (slot.products.length > 2) {
          var arrows = document.createElement('div');
          arrows.className = 'sln-ob__arrows';
          [['<', -1, D.lblPrev], ['>', 1, D.lblNext]].forEach(function (cfg) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'sln-ob__arrow';
            b.textContent = cfg[0];
            b.setAttribute('aria-label', cfg[2] + ' - ' + slot.name);
            b.addEventListener('click', function () {
              track.scrollBy({ left: cfg[1] * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
            });
            arrows.appendChild(b);
          });
          head.appendChild(arrows);
        }
        sec.appendChild(head);
        slot.products.forEach(function (p) {
          if (p.variants && p.variants.length) track.appendChild(buildCard(si, p));
        });
        sec.appendChild(track);
        slotsEl.appendChild(sec);
      });

      function render() {
        cards.forEach(function (arr, si) {
          arr.forEach(function (c) {
            var on = !!(sel[si] && sel[si].p.id === c.p.id);
            c.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (!c.btn.disabled) c.btn.textContent = on ? D.lblSelected : D.lblSelect;
            c.li.classList.toggle('is-selected', on);
          });
        });
        listEl.textContent = '';
        previewEl.textContent = '';
        var count = 0, total = 0;
        sel.forEach(function (s, si) {
          if (!s) return;
          count++;
          var v = variantOf(s);
          total += v.price;
          var li = document.createElement('li');
          var left = document.createElement('span');
          left.textContent = data.slots[si].name + ': ' + s.p.title + (v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
          var right = document.createElement('span');
          right.textContent = fmt.format(v.price / 100);
          li.appendChild(left); li.appendChild(right);
          listEl.appendChild(li);
          if (s.p.image) {
            var im = document.createElement('img');
            im.src = s.p.image; im.alt = '';
            previewEl.appendChild(im);
          }
        });
        totalEl.textContent = fmt.format(total / 100);
        var all = count === data.slots.length;
        bundleEl.hidden = !(all && bundleEl.textContent.trim());
        var ok = count > 0 && (D.requireAll !== 'true' || all);
        addBtn.disabled = !ok;
        contBtn.hidden = true;
        statusEl.textContent = (count > 0 && !ok) ? D.msgIncomplete : '';
      }

      function add(skipSoldOut) {
        var lines = [], bad = [];
        var lookId = 'look-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        sel.forEach(function (s) {
          if (!s) return;
          var v = variantOf(s);
          if (!v || !v.available) { bad.push(s.p.title); return; }
          lines.push({ id: v.id, quantity: 1, properties: { _look_id: lookId, Look: D.lookName || 'Look' } });
        });
        statusEl.textContent = '';
        contBtn.hidden = true;
        if (bad.length && !skipSoldOut) {
          statusEl.textContent = D.msgSoldout + ' ' + bad.join(', ');
          contBtn.hidden = !lines.length;
          return;
        }
        if (!lines.length) return;
        addBtn.disabled = true;
        var drawer = document.querySelector('cart-drawer');
        var payload = { items: lines };
        if (drawer) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
        fetch(D.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message));
            if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
              drawer.renderContents(res.data);
            } else {
              window.location.href = D.cartUrl;
              return;
            }
            statusEl.textContent = D.msgAdded;
            addBtn.disabled = false;
          })
          .catch(function (err) {
            statusEl.textContent = (err && err.message) || D.msgError;
            addBtn.disabled = false;
          });
      }

      addBtn.addEventListener('click', function () { add(false); });
      contBtn.addEventListener('click', function () { add(true); });
      render();
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-sln-ob]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sln-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'sln_recent';

    function readList() {
      try {
        var l = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(l) ? l : [];
      } catch (e) {
        return [];
      }
    }

    function init(root) {
      if (!root || root.dataset.slnInit) return;
      root.dataset.slnInit = '1';
      var cur = root.dataset.current;
      var max = parseInt(root.dataset.max, 10) || 4;
      var rootUrl = root.dataset.root || '/';
      var list = readList();

      if (cur) {
        var next = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 20);
        try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
      }

      var show = list.filter(function (h) { return h !== cur; }).slice(0, max);
      if (!show.length) return;

      var fmt;
      try {
        fmt = new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
      } catch (e) {
        fmt = { format: function (n) { return n.toFixed(2); } };
      }

      Promise.all(
        show.map(function (h) {
          return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        var ul = root.querySelector('[data-sln-rv-list]');
        ul.textContent = '';
        products.forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'sln-rv__card';
          a.href = p.url;
          if (p.featured_image) {
            var img = document.createElement('img');
            img.className = 'sln-rv__img';
            img.loading = 'lazy';
            img.alt = p.title;
            try {
              var u = new URL(p.featured_image, window.location.origin);
              u.searchParams.set('width', '600');
              img.src = u.toString();
            } catch (e) {
              img.src = p.featured_image;
            }
            a.appendChild(img);
          }
          var name = document.createElement('p');
          name.className = 'sln-rv__name';
          name.textContent = p.title;
          var price = document.createElement('p');
          price.className = 'sln-rv__price';
          price.textContent = fmt.format(p.price / 100);
          a.appendChild(name);
          a.appendChild(price);
          li.appendChild(a);
          ul.appendChild(li);
        });
        root.hidden = false;
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-sln-rv]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sln-shoppable-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.slnInit) return;
      root.dataset.slnInit = '1';

      var looks = root.querySelectorAll('[data-sln-look]');
      var idx = 0;
      var count = root.querySelector('[data-sln-count]');
      function showLook(n) {
        idx = (n + looks.length) % looks.length;
        looks.forEach(function (l, i) { l.hidden = i !== idx; });
        if (count) count.textContent = idx + 1 + ' / ' + looks.length;
      }
      var prev = root.querySelector('[data-sln-prev]');
      var next = root.querySelector('[data-sln-next]');
      if (prev) prev.addEventListener('click', function () { showLook(idx - 1); });
      if (next) next.addEventListener('click', function () { showLook(idx + 1); });

      var panel = root.querySelector('[data-sln-panel]');
      var overlay = root.querySelector('[data-sln-overlay]');
      var body = root.querySelector('[data-sln-panel-body]');
      if (!panel) return;

      function closePanel() {
        if (window.slnModal) window.slnModal.close(panel);
        else panel.hidden = true;
      }
      function onClosed() { overlay.hidden = true; body.textContent = ''; }

      function openPanel(key) {
        var tpl = root.querySelector('template[data-sln-tpl="' + key + '"]');
        if (!tpl) return;
        body.textContent = '';
        body.appendChild(tpl.content.cloneNode(true));
        overlay.hidden = false;
        if (window.slnModal) window.slnModal.open(panel, { onClose: onClosed });
        else panel.hidden = false;
        wirePanel();
      }

      function wirePanel() {
        var sel = body.querySelector('select[data-sln-variant]');
        var priceEl = body.querySelector('.sln-lb__pprice');
        if (sel) {
          for (var i = 0; i < sel.options.length; i++) {
            if (!sel.options[i].disabled) { sel.selectedIndex = i; break; }
          }
          var upd = function () {
            var o = sel.options[sel.selectedIndex];
            if (o && o.dataset.price && priceEl) priceEl.textContent = o.dataset.price;
          };
          sel.addEventListener('change', upd);
          upd();
        }
        var btn = body.querySelector('[data-sln-add]');
        var status = body.querySelector('[data-sln-status]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var vEl = body.querySelector('[data-sln-variant]');
          var id = vEl && vEl.value;
          if (!id) return;
          btn.disabled = true;
          status.textContent = '';
          var cartDrawer = document.querySelector('cart-drawer');
          var payload = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
          if (cartDrawer) {
            payload.sections = 'cart-drawer,cart-icon-bubble';
            payload.sections_url = window.location.pathname;
          }
          fetch(root.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message));
              if (cartDrawer && typeof cartDrawer.renderContents === 'function' && res.data.sections) {
                closePanel();
                cartDrawer.renderContents(res.data);
              } else {
                status.textContent = root.dataset.msgAdded;
                btn.disabled = false;
                if (!cartDrawer) window.location.href = root.dataset.cartUrl;
              }
            })
            .catch(function (err) {
              status.textContent = (err && err.message) || root.dataset.msgError;
              btn.disabled = false;
            });
        });
      }

      root.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-sln-open]');
        if (dot) { openPanel(dot.getAttribute('data-sln-open')); return; }
        if (e.target.closest('[data-sln-close]') || e.target === overlay) closePanel();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-sln-lb]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sln-wishlist"]) return;
  try {
    
  (function () {
    function money(root) {
      try { return new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }); }
      catch (e) { return { format: function (n) { return n.toFixed(2); } }; }
    }

    function init(root) {
      if (!root || root.dataset.slnInit) return;
      var Wl = window.slnWl;
      if (!Wl) return false;
      root.dataset.slnInit = '1';

      var list = root.querySelector('[data-sln-list]');
      var empty = root.querySelector('[data-sln-empty]');
      var status = root.querySelector('[data-sln-status]');
      var bar = root.querySelector('[data-sln-bar]');
      var shareBtn = root.querySelector('[data-sln-share]');
      var clearBtn = root.querySelector('[data-sln-clear]');
      var saveAll = root.querySelector('[data-sln-saveall]');
      var rootUrl = root.dataset.root || '/';
      var fmt = money(root);
      var qs = new URLSearchParams(window.location.search).get('items');
      var shared = qs ? qs.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 40) : null;
      var cache = {};
      var pendingNote = '';

      if (shared) { shareBtn.hidden = true; clearBtn.hidden = true; saveAll.hidden = false; }

      function fetchP(h) {
        if (Object.prototype.hasOwnProperty.call(cache, h)) return Promise.resolve(cache[h]);
        return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (p) { cache[h] = p; return p; });
      }

      function cardEl(p) {
        var li = document.createElement('li');
        li.className = 'sln-wlp__item';
        var a = document.createElement('a');
        a.className = 'sln-wlp__media';
        a.href = p.url;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.loading = 'lazy';
          img.alt = p.title;
          try { var u = new URL(p.featured_image, window.location.origin); u.searchParams.set('width', '600'); img.src = u.toString(); }
          catch (e) { img.src = p.featured_image; }
          a.appendChild(img);
        }
        if (!p.available) {
          var badge = document.createElement('span');
          badge.className = 'sln-wlp__badge';
          badge.textContent = root.dataset.lblSoldout;
          a.appendChild(badge);
        }
        li.appendChild(a);

        var h3 = document.createElement('h3');
        h3.className = 'sln-wlp__name';
        var ha = document.createElement('a');
        ha.href = p.url;
        ha.textContent = p.title;
        h3.appendChild(ha);
        li.appendChild(h3);

        var price = document.createElement('p');
        price.className = 'sln-wlp__price';
        li.appendChild(price);

        var sel = null;
        var variants = p.variants || [];
        function firstAvail() { for (var i = 0; i < variants.length; i++) if (variants[i].available) return variants[i]; return variants[0]; }
        if (variants.length > 1) {
          sel = document.createElement('select');
          sel.setAttribute('aria-label', p.title);
          variants.forEach(function (v) {
            var o = document.createElement('option');
            o.value = String(v.id);
            o.textContent = v.title + (v.available ? '' : ' - ' + root.dataset.lblSoldout);
            o.disabled = !v.available;
            sel.appendChild(o);
          });
          sel.value = String(firstAvail().id);
          li.appendChild(sel);
        }
        function current() {
          if (!sel) return variants[0];
          for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === sel.value) return variants[i];
          return variants[0];
        }
        function paint() { price.textContent = fmt.format(current().price / 100); }
        if (sel) sel.addEventListener('change', paint);
        paint();

        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'button';
        add.textContent = p.available ? root.dataset.lblAdd : root.dataset.lblSoldout;
        add.disabled = !p.available;
        add.addEventListener('click', function () {
          var v = current();
          if (!v || !v.available) return;
          add.disabled = true;
          var drawer = document.querySelector('cart-drawer');
          var payload = { items: [{ id: v.id, quantity: 1 }] };
          if (drawer) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
          fetch(root.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message));
              if (!shared) Wl.remove(p.handle);
              if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
                drawer.renderContents(res.data);
              } else {
                status.textContent = root.dataset.msgAdded;
                if (!drawer) window.location.href = root.dataset.cartUrl;
              }
              add.disabled = false;
            })
            .catch(function (err) {
              status.textContent = (err && err.message) || root.dataset.msgError;
              add.disabled = false;
            });
        });
        li.appendChild(add);

        if (!shared) {
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'sln-wlp__remove';
          rm.textContent = root.dataset.lblRemove;
          rm.addEventListener('click', function () { Wl.remove(p.handle); });
          li.appendChild(rm);
        }
        return li;
      }

      function render() {
        var hs = shared || Wl.all();
        status.textContent = pendingNote;
        pendingNote = '';
        if (!hs.length) { list.textContent = ''; empty.hidden = false; bar.hidden = true; return; }
        Promise.all(hs.map(fetchP)).then(function (ps) {
          var ok = [];
          var gone = [];
          ps.forEach(function (p, i) { if (p) ok.push(p); else gone.push(hs[i]); });
          if (!shared && gone.length) {
            pendingNote = root.dataset.msgGone;
            Wl.set(Wl.all().filter(function (h) { return gone.indexOf(h) === -1; }));
            return;
          }
          list.textContent = '';
          ok.forEach(function (p) { list.appendChild(cardEl(p)); });
          empty.hidden = ok.length > 0;
          bar.hidden = !ok.length;
        });
      }

      shareBtn.addEventListener('click', function () {
        var url = window.location.origin + window.location.pathname + '?items=' + encodeURIComponent(Wl.all().join(','));
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { status.textContent = root.dataset.msgCopied; })
            .catch(function () { window.prompt(root.dataset.msgCopyPrompt, url); });
        } else {
          window.prompt(root.dataset.msgCopyPrompt, url);
        }
      });
      clearBtn.addEventListener('click', function () { Wl.clear(); });
      saveAll.addEventListener('click', function () {
        var merged = Wl.all();
        (shared || []).forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
        Wl.set(merged);
        window.location.href = window.location.pathname;
      });

      Wl.onChange(function () { if (!shared) render(); });
      render();
    }

    function initAll(scope) {
      var tries = 0;
      (function attempt() {
        var pending = false;
        (scope || document).querySelectorAll('[data-sln-wlp]').forEach(function (r) { if (init(r) === false) pending = true; });
        if (pending && tries++ < 60) setTimeout(attempt, 50);
      })();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
